const setItem = async (key, value) => {
    if (window.localStorage) {
        localStorage.setItem(key, value);
    }
};
const getItem = async (key) => {
    if (window.localStorage) {
        return localStorage.getItem(key);
    }
    return '';
};

export default { getItem, setItem };
